function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.522 18.27a1 1 0 11-1.338 1.487l-7.866-7.08a1 1 0 010-1.487l7.866-7.08a1 1 0 111.338 1.487l-7.04 6.336 7.04 6.337z",
  fill: "#A4B8D1"
});

var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none"
  }), _ref);
};

export default SvgArrowLeft;